<script>
export default {
  name: 'ApiPageEndpoints',

  props: {
    endpoints: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    formatedEndpoints() {
      return this.endpoints.map((endpoint) => this.formatEndpoint(endpoint));
    },
  },

  methods: {
    formatEndpoint(endpoint) {
      const rgx = /\[(.+)\]\((.+)\)/g;
      const [, method, url] = rgx.exec(endpoint);
      return { method, url };
    },
  },
};
</script>

<template>
  <div class="code-block">
    <div class="header">Endpoints</div>

    <div class="content">
      <table>
        <tr v-for="(endpoint, i) in formatedEndpoints" :key="i">
          <td class="method">{{ endpoint.method }}</td>
          <td class="url">{{ endpoint.url }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.code-block {
  .header {
    @include caption-bold;
    color: $code-block-text-color-secondary;
    border-top-left-radius: $space-4;
    border-top-right-radius: $space-4;
    padding: $space-12 $space-16;
    background-color: $code-block-background-color-secondary;
  }

  .content {
    overflow-x: scroll;
    @include caption-regular;
    font-family: $font-family-code;
    background-color: $code-block-background-color-primary;
    padding: $space-8;
    border-bottom-left-radius: $space-4;
    border-bottom-right-radius: $space-4;
    color: $code-block-text-color-primary;

    @include tablet-large {
      padding: $space-24 - $space-8;
    }

    .method {
      padding: $space-8;
      text-align: right;
      @include caption-bold;
    }
  }
}

@media print {
  .code-block {
    print-color-adjust: exact;

    .header,
    .content {
      background-color: $background-color-secondary;
      color: $text-color-primary;
      word-break: break-all !important;
      white-space: pre-wrap;
    }
  }
}
</style>
